import { Component, Input, OnInit } from '@angular/core'
import { select, Store } from '@ngrx/store'
import {
  Channel,
  ConfirmDialogService,
  Destroyable,
  selectChannelEntities,
  untilDestroy,
} from '@tokeet-frontend/tv3-platform'
import { DeleteMinStayAutomation, MinStayAutomation } from '@tokeet-frontend/rate-automations'
import { MinStayAutomationDialogService } from '../automation-dialog/min-stay-automation-dialog.service'
@Component({
  selector: 'app-min-stay-automations-grid',
  templateUrl: './min-stay-automations-grid.component.html',
  styleUrls: ['./min-stay-automations-grid.component.scss'],
})
export class MinStayAutomationsGridComponent extends Destroyable implements OnInit {
  @Input() items: MinStayAutomation[] = []

  channelsById: Record<string, Channel> = {}

  constructor(
    private store: Store<any>,
    private confirmDialog: ConfirmDialogService,
    private minStayAutomationDialog: MinStayAutomationDialogService
  ) {
    super()
  }

  ngOnInit(): void {
    this.store.pipe(select(selectChannelEntities), untilDestroy(this)).subscribe((data) => {
      this.channelsById = data
    })
  }

  onEdit(item: MinStayAutomation) {
    this.minStayAutomationDialog.open({ minStay: item })
  }

  onDelete(item: MinStayAutomation) {
    this.confirmDialog
      .confirm({
        title: $localize`Delete this automation?`,
        body: $localize`Are you sure you want to delete this automation?`,
      })
      .subscribe(() => {
        this.store.dispatch(DeleteMinStayAutomation({ id: item.key }))
      })
  }
}
